export default function(data) {
  const transformedData = {
    items: [
      {
        tables: [
          {
            round: {
              id: 1
            },
            table: {
              rows: [
              ]
            }
          }
        ]
      }
    ]
  };

  for (let i = 0; i < data.player.length; i++) {
    transformedData.items[0].tables[0].table.rows.push({
      id: i + 1,
      name: data.player[i].name,
      sets: data.player[i].sets,
      legs: data.player[i].legs,
      score: data.player[i].score,
      180: data.player[i].oneeighties,
      140: data.player[i].onefourties,
      100: data.player[i].onehundreds,
      doubles: data.player[i].hitdoubles
    });
  }

  return transformedData;
}
